import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill", "stroke"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'plus',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
  size: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      id: "Vector",
      d: "M0.75 7C0.75 7.26522 0.855357 7.51957 1.04289 7.70711C1.23043 7.89464 1.48478 8 1.75 8H6V12.25C6 12.5152 6.10536 12.7696 6.29289 12.9571C6.48043 13.1446 6.73478 13.25 7 13.25C7.26522 13.25 7.51957 13.1446 7.70711 12.9571C7.89464 12.7696 8 12.5152 8 12.25V8H12.25C12.5152 8 12.7696 7.89464 12.9571 7.70711C13.1446 7.51957 13.25 7.26522 13.25 7C13.25 6.73478 13.1446 6.48043 12.9571 6.29289C12.7696 6.10536 12.5152 6 12.25 6H8V1.75C8 1.48478 7.89464 1.23043 7.70711 1.04289C7.51957 0.855357 7.26522 0.75 7 0.75C6.73478 0.75 6.48043 0.855357 6.29289 1.04289C6.10536 1.23043 6 1.48478 6 1.75V6H1.75C1.48478 6 1.23043 6.10536 1.04289 6.29289C0.855357 6.48043 0.75 6.73478 0.75 7Z",
      fill: __props.color,
      stroke: __props.color,
      "stroke-width": "0.5"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})